export const pt = {
    appTitle: `Gerenciamento de Contas`,
    loading: `Carregando...`,
    emailLabel: `E-mail`,
    emailPlaceholder: `Digite seu e-mail`,
    passwordLabel: `Senha`,
    passwordPlaceholder: `Digite sua senha`,
    firstNameLabel: `Nome`,
    firstNamePlaceholder: `Nome`,
    lastNameLabel: `Sobrenome`,
    lastNamePlaceholder: `Sobrenome`,
    confirmPasswordLabel: `Confirmar senha`,
    confirmPasswordPlaceholder: `Confirmar senha`,
    currentPasswordLabel: `Senha atual`,
    currentPasswordPlaceholder: `Senha atual`,
    newPasswordLabel: `Nova senha`,
    newPasswordPlaceholder: `Nova senha`,
    confirmNewPasswordLabel: `Confirmar nova senha`,
    confirmNewPasswordPlaceholder: `Confirmar nova senha`,
    resetTokenLabel: `Token de redefinição`,
    resetTokenPlaceholder: `Token de redefinição`,
    serverError: `O servidor está enfrentando problemas. Por favor tente novamente mais tarde ou entre em contato com o suporte se o problema persistir.`,
    networkError: `Não foi possível conectar ao servidor. Verifique sua conexão com a internet e tente novamente.`,
    passwordsDoNotMatch: `As senhas não coincidem`,
    supportContact: `Para suporte, contate:`,
    backToLogin: `Voltar para login`,
    backToSignIn: `Voltar para entrar`,
    signIn: `Entrar`,
    signUp: `Cadastrar`,
    createAccount: `Criar conta`,
    continueToSignIn: `Continuar para entrar`,
    continueNow: `Continuar agora`,
    createNewAccount: `Criar nova conta`,
    invalidConfirmationLink: `Link de confirmação inválido. Verifique seu e-mail para o link correto.`,
    pleaseFillAllFields: `Por favor preencha todos os campos`,
    redirectNow: `Redirecionar agora`,
    cancel: `Cancelar`,
    redirecting: `Redirecionando...`,
    cancelAction: `cancelar`,
    toggleTheme: `Alternar tema`,
    language: `Idioma`,
    languageAuto: `Automático`,
    languageEn: `Inglês`,
    languageEs: `Espanhol`,
    languagePt: `Português`,
    providerGoogle: `Google`,
    providerMicrosoft: `Microsoft`,
    providerFacebook: `Facebook`,
    providerGithub: `GitHub`,
    signInWith: `Entrar com {provider}`,
    redirectProgressAria: `Progresso de redirecionamento`,
    redirectingToResendConfirmationEmail: `Redirecionando para reenviar e-mail de confirmação...`,
};
//# sourceMappingURL=pt.js.map